// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BenchmarkVersionHistory_wrap__pRtLv {
  display: flex;
  flex-direction: column;
}

.BenchmarkVersionHistory_hint__qVf5I {
  margin: 0 0 12px;
  font-size: 11.5px;
  color: #94a3b8;
  line-height: 1.45;
}

.BenchmarkVersionHistory_loading__QTQIV,
.BenchmarkVersionHistory_empty__MmRrD {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 0;
  color: #64748b;
  font-size: 14px;
}

.BenchmarkVersionHistory_list__ZiGW2 {
  list-style: none;
  margin: 0;
  padding: 0;
}

.BenchmarkVersionHistory_row__8U6m4 {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px 11px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  margin-bottom: 8px;
}
.BenchmarkVersionHistory_row--current__s35al {
  border-color: #cbd5e1;
  background: #f8fafc;
}

.BenchmarkVersionHistory_meta__2lB37 {
  min-width: 0;
}

.BenchmarkVersionHistory_titleRow__8lfxP {
  display: flex;
  align-items: center;
  gap: 8px;
}

.BenchmarkVersionHistory_version__6Cr5l {
  font-size: 14px;
  font-weight: 700;
  color: #1e293b;
}

.BenchmarkVersionHistory_badge__TWZA9 {
  font-size: 10.5px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: #0f3460;
  background: #e0e7ff;
  border-radius: 999px;
  padding: 2px 8px;
}
.BenchmarkVersionHistory_badge--preview__xup67 {
  font-size: 10.5px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: #b45309;
  background: #fef3c7;
  border-radius: 999px;
  padding: 2px 8px;
}

.BenchmarkVersionHistory_label__grlTa {
  margin-top: 3px;
  font-size: 12.5px;
  color: #334155;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.BenchmarkVersionHistory_noLabel__wk6k4 {
  color: #94a3b8;
}

.BenchmarkVersionHistory_time__HWrpS {
  margin-top: 2px;
  font-size: 12px;
  color: #94a3b8;
}

.BenchmarkVersionHistory_actions__Yf7Dd {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}
.BenchmarkVersionHistory_actions__Yf7Dd button {
  flex: 1 1;
}

.BenchmarkVersionHistory_btnGhost__vmMXs {
  border: 1px solid #e2e8f0;
  background: #fff;
  color: #475569;
  font-size: 12.5px;
  font-weight: 600;
  border-radius: 8px;
  padding: 7px 12px;
  cursor: pointer;
}
.BenchmarkVersionHistory_btnGhost__vmMXs:hover:not(:disabled) {
  background: #f1f5f9;
}
.BenchmarkVersionHistory_btnGhost__vmMXs:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.BenchmarkVersionHistory_btnPrimary__KjMzP {
  border: none;
  background: linear-gradient(135deg, #f0703a 0%, #e8622c 100%);
  color: #fff;
  font-size: 12.5px;
  font-weight: 600;
  border-radius: 8px;
  padding: 8px 14px;
  cursor: pointer;
}
.BenchmarkVersionHistory_btnPrimary__KjMzP:hover:not(:disabled) {
  box-shadow: 0 4px 12px rgba(232, 98, 44, 0.32);
}
.BenchmarkVersionHistory_btnPrimary__KjMzP:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.BenchmarkVersionHistory_pager__JUVJS {
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/KeywordBenchmark/Components/BenchmarkVersionHistory/BenchmarkVersionHistory.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;AACF;;AAEA;;EAEE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AACF;;AAEA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;AACF;AACE;EACE,qBAAA;EACA,mBAAA;AACJ;;AAGA;EACE,YAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAAF;;AAGA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAAF;;AAGA;EACE,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;AAAF;AAEE;EACE,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;AAAJ;;AAIA;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,eAAA;EACA,eAAA;EACA,cAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AADF;AAGE;EACE,SAAA;AADJ;;AAKA;EACE,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AAFF;AAIE;EACE,mBAAA;AAFJ;AAKE;EACE,YAAA;EACA,mBAAA;AAHJ;;AAOA;EACE,YAAA;EACA,6DAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AAJF;AAME;EACE,8CAAA;AAJJ;AAOE;EACE,YAAA;EACA,mBAAA;AALJ;;AASA;EACE,aAAA;EACA,yBAAA;EACA,gBAAA;AANF","sourcesContent":[".wrap {\n  display: flex;\n  flex-direction: column;\n}\n\n.hint {\n  margin: 0 0 12px;\n  font-size: 11.5px;\n  color: #94a3b8;\n  line-height: 1.45;\n}\n\n.loading,\n.empty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 40px 0;\n  color: #64748b;\n  font-size: 14px;\n}\n\n.list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.row {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 10px 11px;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  margin-bottom: 8px;\n\n  &--current {\n    border-color: #cbd5e1;\n    background: #f8fafc;\n  }\n}\n\n.meta {\n  min-width: 0;\n}\n\n.titleRow {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.version {\n  font-size: 14px;\n  font-weight: 700;\n  color: #1e293b;\n}\n\n.badge {\n  font-size: 10.5px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  color: #0f3460;\n  background: #e0e7ff;\n  border-radius: 999px;\n  padding: 2px 8px;\n\n  &--preview {\n    font-size: 10.5px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.4px;\n    color: #b45309;\n    background: #fef3c7;\n    border-radius: 999px;\n    padding: 2px 8px;\n  }\n}\n\n.label {\n  margin-top: 3px;\n  font-size: 12.5px;\n  color: #334155;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.noLabel {\n  color: #94a3b8;\n}\n\n.time {\n  margin-top: 2px;\n  font-size: 12px;\n  color: #94a3b8;\n}\n\n.actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n\n  button {\n    flex: 1;\n  }\n}\n\n.btnGhost {\n  border: 1px solid #e2e8f0;\n  background: #fff;\n  color: #475569;\n  font-size: 12.5px;\n  font-weight: 600;\n  border-radius: 8px;\n  padding: 7px 12px;\n  cursor: pointer;\n\n  &:hover:not(:disabled) {\n    background: #f1f5f9;\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n}\n\n.btnPrimary {\n  border: none;\n  background: linear-gradient(135deg, #f0703a 0%, #e8622c 100%);\n  color: #fff;\n  font-size: 12.5px;\n  font-weight: 600;\n  border-radius: 8px;\n  padding: 8px 14px;\n  cursor: pointer;\n\n  &:hover:not(:disabled) {\n    box-shadow: 0 4px 12px rgba(232, 98, 44, 0.32);\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n}\n\n.pager {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `BenchmarkVersionHistory_wrap__pRtLv`,
	"hint": `BenchmarkVersionHistory_hint__qVf5I`,
	"loading": `BenchmarkVersionHistory_loading__QTQIV`,
	"empty": `BenchmarkVersionHistory_empty__MmRrD`,
	"list": `BenchmarkVersionHistory_list__ZiGW2`,
	"row": `BenchmarkVersionHistory_row__8U6m4`,
	"row--current": `BenchmarkVersionHistory_row--current__s35al`,
	"meta": `BenchmarkVersionHistory_meta__2lB37`,
	"titleRow": `BenchmarkVersionHistory_titleRow__8lfxP`,
	"version": `BenchmarkVersionHistory_version__6Cr5l`,
	"badge": `BenchmarkVersionHistory_badge__TWZA9`,
	"badge--preview": `BenchmarkVersionHistory_badge--preview__xup67`,
	"label": `BenchmarkVersionHistory_label__grlTa`,
	"noLabel": `BenchmarkVersionHistory_noLabel__wk6k4`,
	"time": `BenchmarkVersionHistory_time__HWrpS`,
	"actions": `BenchmarkVersionHistory_actions__Yf7Dd`,
	"btnGhost": `BenchmarkVersionHistory_btnGhost__vmMXs`,
	"btnPrimary": `BenchmarkVersionHistory_btnPrimary__KjMzP`,
	"pager": `BenchmarkVersionHistory_pager__JUVJS`
};
export default ___CSS_LOADER_EXPORT___;
